import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  Text,
  Card,
  Flex,
  Box,
  Badge,
  SimpleGrid,
  Tooltip,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Button,
} from '@chakra-ui/react';
import RBarChart from './RBarChart';
import { fetchStats, fetchStatsChart } from '../../api/tabsApi';
import { TState } from '../../redux/store';
import { SpinnerIcon } from '@chakra-ui/icons';
import { allIcons, NormalIcon } from '../utils/Icon';
import { useTagFilter } from '../table/tableComponents/DynamicFilters';

export const colors = {
  prev: '#8f9bba',
  curr: '#4a8bf4',
};

const StatsSettings = () => {
  const theme = useSelector((state: TState) => state.theme);

  const [stats, setStats] = useState<any[]>([]);

  const tagFilter = useTagFilter();

  useEffect(() => {
    const getStats = async () => {
      const resp = await fetchStats();

      setStats(resp.data.map((d: any) => ({ stats: d })));

      resp.data.forEach(async (s: any, idx: number) => {
        const resp = await fetchStatsChart(s._id);

        setStats((c) => {
          const newC = [...c];
          newC[idx] = resp;
          return newC;
        });
      });
    };

    getStats();
  }, []);

  return (
    <SimpleGrid columns={[1, 1, 1, 2]} spacing={3} overflow='auto'>
      {stats?.map((s) => {
        const {
          data,
          duration,
          title,
          type,
          isCompare,
          stats: { filtersToApply, filtersOptions },
        } = s;
        return (
          <Card
            p={3}
            pb={2}
            bgColor='#f9fafb'
            alignItems='center'
            h={'400px'}
            flexShrink={1}
            flexDirection='column'
            justifyContent='center'
          >
            {data ? (
              <>
                <Flex gap={2} w='100%' alignItems='center'>
                  <Badge>{title}</Badge>
                  <Flex
                    fontSize={theme.fontSize.xSmall}
                    gap={1}
                    justifyContent='right'
                    flexGrow={1}
                    alignItems='center'
                  >
                    {type === 'compare' && (
                      <>
                        <Box
                          boxSize={5}
                          bgColor={colors.prev}
                          borderRadius={5}
                        />
                        <Text mr={2} textTransform='uppercase'>
                          {duration === 'week'
                            ? 'Semaine dernière'
                            : duration === 'month'
                              ? 'Mois dernier'
                              : 'Année dernière'}
                        </Text>
                      </>
                    )}
                    {(isCompare || !data.legend?.length) && (
                      <Box boxSize={5} bgColor={colors.curr} borderRadius={5} />
                    )}
                    <Text textTransform='uppercase'>
                      {duration === 'week'
                        ? 'Semaine en cours'
                        : duration === 'month'
                          ? 'Mois en cours'
                          : 'Année en cours'}
                    </Text>
                  </Flex>
                  {filtersToApply?.length ? (
                    <Popover>
                      <PopoverTrigger>
                        <Button p={0} size='xs'>
                          <Tooltip label='Voir les filtres'>
                            <span>
                              <NormalIcon
                                boxSize={4}
                                as={allIcons.HiFunnel}
                                onClick={() => {}}
                              />
                            </span>
                          </Tooltip>
                        </Button>
                      </PopoverTrigger>
                      <PopoverContent maxW={500} w='auto'>
                        <PopoverArrow />
                        <PopoverBody>
                          <Flex gap={2} flexWrap='wrap'>
                            {tagFilter(
                              filtersToApply.reduce(
                                (p: any, k: string) => ({
                                  ...p,
                                  [k]: filtersOptions[k],
                                }),
                                {},
                              ),
                            )}
                          </Flex>
                        </PopoverBody>
                      </PopoverContent>
                    </Popover>
                  ) : null}
                </Flex>
                <Flex
                  fontSize={theme.fontSize.xSmall}
                  gap={1}
                  justifyContent='center'
                  mt={1}
                  flexWrap='wrap'
                  alignItems='center'
                >
                  {data.legend?.map(
                    (user: { text: string; fillStyle: string }) => (
                      <>
                        <Box
                          boxSize={5}
                          bgColor={user.fillStyle}
                          borderRadius={5}
                        />
                        <Text mr={2}>{user.text}</Text>
                      </>
                    ),
                  )}
                </Flex>
                <Flex flexGrow={1} w={'100%'} flexDirection='column'>
                  <RBarChart
                    data={data}
                    isCompare={isCompare && data.legend?.length}
                  />
                </Flex>
              </>
            ) : (
              <SpinnerIcon
                boxSize='40px'
                color={`${theme.dark} !important`}
                style={{
                  animation: 'spin .5s linear infinite',
                  color: 'currentcolor',
                }}
              />
            )}
          </Card>
        );
      })}
      {/* <RLineChart /> */}
    </SimpleGrid>
  );
};

export default StatsSettings;
